var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.81818C24 9.23953 23.7701 8.68457 23.361 8.2754C22.9518 7.86623 22.3968 7.63636 21.8182 7.63636H14.9236L15.9709 2.65091C15.9927 2.54182 16.0036 2.42182 16.0036 2.30182C16.0036 1.85455 15.8182 1.44 15.5236 1.14545L14.3673 0L7.18909 7.17818C6.78545 7.58182 6.54545 8.12727 6.54545 8.72727V19.6364C6.54545 20.215 6.77532 20.77 7.18449 21.1791C7.59366 21.5883 8.14862 21.8182 8.72727 21.8182H18.5455C19.4509 21.8182 20.2255 21.2727 20.5527 20.4873L23.8473 12.7964C23.9455 12.5455 24 12.2836 24 12V9.81818ZM0 21.8182H4.36364V8.72727H0V21.8182Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.654aa7469f686e8c386c343bd80f9e6b.svg";
export { ForwardRef as ReactComponent };